<template>
 <div></div>
</template>
<script>
export default {
  name: 'team',
  data(){
    return{

    }
  }
}
</script>
<style scoped>
img{
  width: 150px;
  margin: auto;
}
.team-item:hover>.person-name{
  color: #f2c303;
  transition: color .4s;
}
</style>